<!--
2026-05-07 YTW 预测竞猜-MVP
-->
<template>
  <div class="main-content" id="main-content">
    <div class="phone">
      <div class="hdr">
        <TopBack style="position: relative" :title="$t('lang.predict.mybets')"/>
      </div>
      <div class="scr" style="padding-top:1vw;"
           ref="scr"
           @touchstart="touchStart"
           @touchmove="touchMove"
           @touchend="touchEnd">
        <div class="scr-inner" :style="{transform: `translate3d(0, ${pullY}px, 0)`}">
          <div class="sec-lbl">Recent</div>
          <div class="bet-card" v-for="(card, index) in myBetList" :key="index">
            <div class="bet-top">
              <div class="bet-q" v-if="$store.state.locale==='EN'">{{ card.ContentEnglish }}</div>
              <div class="bet-q" v-else>{{ card.ContentHindi }}</div>
              <div class="bet-date">{{ card.PredictDateDisplay }}</div>
            </div>
            <div class="bet-detail">
              <div class="bet-sa" v-if="card.BetSide === 'Yes'"><span class="pill yes-pill">YES</span><span
                class="b-amt">{{ $t('lang.account.currencyType') }}{{ card.StakeAmount }}</span></div>
              <div class="bet-sa" v-if="card.BetSide === 'No'"><span class="pill no-pill">NO</span><span
                class="b-amt">{{ $t('lang.account.currencyType') }}{{ card.StakeAmount }}</span></div>
              <span class="s-won" v-if="card.BetResult==='Won'">{{ winText(card) }}</span>
              <span class="s-lost" v-else-if="card.BetResult==='Lost'">{{ $t('lang.predict.lost') }}</span>
              <span class="s-pend" v-else-if="card.BetResult==='Refunded'"></span>
              <span class="s-pend" v-else>{{ $t('lang.predict.pending') }}</span>
            </div>
          </div>
          <div class="hint">{{ $t('lang.predict.bottom') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopBack from '@/components/TopBack/index'
import request from '@/service'

export default {
  name: 'PredictRecord',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      myBetList: [],
      pullY: 0,
      startY: 0,
      canPull: false
    }
  },
  components: {
    TopBack
  },
  watch: {},
  created () {
  },
  mounted () {
    this.getData()
  },
  methods: {
    winText (card) {
      return this.$t('lang.predict.won').replace('{amount}', card.WinAmount)
    },
    getData () {
      const data = {userId: this.userInfo.UserId}
      request('post', '/innovation/predict/myBets', data).then(res => {
        if (res.Code === 1) {
          this.myBetList = res.Bets
        }
      })
    },
    goBack () {
      this.$router.go(-1)
    },
    goto (path) {
      this.$router.push('/' + path)
    },
    touchStart (e) {
      const el = this.$refs.scr
      // 必须在顶部
      this.canPull = el.scrollTop <= 0
      if (this.canPull) {
        this.startY = e.touches[0].clientY
      }
    },
    touchMove (e) {
      if (!this.canPull) return
      const currentY = e.touches[0].clientY
      let distance = currentY - this.startY
      // 只允许下拉
      if (distance <= 0) return
      // 阻尼
      distance *= 0.35
      // 最大距离
      if (distance > 120) {
        distance = 120
      }
      this.pullY = distance
    },
    touchEnd () {
      if (this.pullY > 80) {
        this.getData()
      }
      this.canPull = false
      this.pullY = 0
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: fixed;
  padding: 56px 0 0 0;
  width: 100vw;
  height: 100dvh;
  background-color: #000000;
  display: flex;
  overflow: hidden;

  .relative {
    position: absolute;
    width: 100vw;
    height: max-content;
    z-index: 0;
  }

  .rules {
    position: relative;
    top: 21.6667vw;
    left: 50%;
    transform: translate(-50%);
    width: 90.555vw;
    height: max-content;
    padding-bottom: 10vw;

    .title {
      font-family: Inter;
      font-size: 6.111vw;
      font-weight: 700;
      line-height: 6.388vw;
      text-align: left;
      color: #FFFFFF;
      margin-bottom: 2vw;
    }

    .content {
      padding: 2vw 0 0 1.111vw;
      font-family: Inter;
      font-size: 4.166vw;
      font-weight: 500;
      line-height: 5.556vw;
      text-align: left;
      color: #FFFFFF;
      height: max-content;

      p {
        margin-bottom: 1vw;
      }
    }
  }

  .panel {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.66);

    .modal {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 83.333vw;
      height: 55.556vw;
      background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      border: 0.277vw solid #737373;
      border-radius: 4.166vw;

      .top {
        margin-top: 4vw;
        text-align: center;
        font-size: 5.556vw;
        font-weight: 700;
        color: #FFFFFF;
      }

      .message {
        position: relative;
        top: 3vw;
        left: 50%;
        transform: translate(-50%);
        width: 68.672vw;
        height: max-content;
        color: #C4C4C4;
        font-size: 3.888vw;
        font-weight: 400;
        line-height: 5.556vw;
        letter-spacing: 0.02em;
      }

      .buttons {
        position: relative;
        top: 8vw;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        width: 69.444vw;
        height: 8.333vw;
        justify-content: space-between;

        .btn {
          width: 32.222vw;
          height: 8.333vw;
          line-height: 8.333vw;
          text-align: center;
          background: linear-gradient(270.12deg, #DEBC86 -2.41%, #F7DEB8 113.36%);
          font-family: Inter;
          font-size: 3.889vw;
          font-weight: 500;
          color: #000000;
          border-radius: 0.833vw;
        }

        .ok {
          margin-top: 3.8vw;
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: #1c1c1e;
  font-family: -apple-system, 'Helvetica Neue', sans-serif;
  color: #fff;
  padding: 11.11vw 6.67vw;
}

h1 {
  font-size: 6.11vw;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 1.11vw;
}

.subtitle {
  font-size: 3.61vw;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 11.11vw;
}

.spec-section-title {
  font-size: 3.06vw;
  font-weight: 700;
  letter-spacing: 0.001em;
  text-transform: uppercase;
  color: rgba(246, 217, 170, 0.5);
  margin-bottom: 5.56vw;
  padding-bottom: 2.22vw;
  border-bottom: 0.28vw solid rgba(255, 255, 255, 0.06);
}

/* ── TYPE TABLE ── */
table {
  width: 100%;
  border-collapse: collapse;
}

th {
  font-size: 3.06vw;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.35);
  text-align: left;
  padding: 1.67vw 3.33vw;
  letter-spacing: 0.14vw;
}

td {
  font-size: 3.61vw;
  color: rgba(255, 255, 255, 0.8);
  padding: 2.22vw 3.33vw;
  border-top: 0.28vw solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
}

td:first-child {
  color: rgba(255, 255, 255, 0.45);
  font-size: 3.33vw;
}

.preview {
  display: inline-block;
}

/* ── COMPONENT SPECS ── */
.comp-row {
  display: flex;
  gap: 8.89vw;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 8.89vw;
}

.comp-box {
  flex-shrink: 0;
}

.comp-label {
  font-size: 3.06vw;
  color: rgba(255, 255, 255, 0.3);
  margin-bottom: 2.78vw;
  letter-spacing: 0.14vw;
}

.anno-box {
  flex: 1;
  min-width: 72.22vw;
}

.anno-title {
  font-size: 3.33vw;
  font-weight: 600;
  color: rgba(246, 217, 170, 0.7);
  margin-bottom: 2.78vw;
}

.anno-row {
  display: flex;
  justify-content: space-between;
  padding: 1.39vw 0;
  border-bottom: 0.28vw solid rgba(255, 255, 255, 0.04);
}

.anno-key {
  font-size: 3.33vw;
  color: rgba(255, 255, 255, 0.4);
}

.anno-val {
  font-size: 3.33vw;
  color: #fff;
  font-family: 'SF Mono', monospace;
  text-align: right;
}

.phone {
  position: relative;
  width: 100vw;
  height: calc(100dvh - 56px);
  background: #090909;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.phone-inner {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── REDLINE OVERLAY HELPERS ── */
.rl {
  position: relative;
}

.rl::after {
  content: attr(data-anno);
  position: absolute;
  right: -36.11vw;
  top: 50%;
  transform: translateY(-50%);
  font-size: 2.777vw;
  color: #ff6b6b;
  white-space: nowrap;
  font-family: 'SF Mono', monospace;
  pointer-events: none;
}

.rl-t::after {
  top: -5vw;
  right: auto;
  left: 0;
  transform: none;
}

.rl-b::after {
  top: auto;
  bottom: -5vw;
  right: auto;
  left: 0;
  transform: none;
}

.hdr {
  padding: 0 5.555vw 2.22vw 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.hdr-title {
  color: var(--primary-color);
  font-size: 5.56vw;
  font-weight: 700;
}

.hdr-btn {
  color: var(--primary-color);
  font-size: 3.61vw;
  border: 0.28vw solid rgba(246, 217, 170, 0.3);
  border-radius: 5.555vw;
  padding: 1.39vw 3.33vw;
  margin-top: 2.5vw;
  background: transparent;
}

.scr {
  position: relative;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 1.11vw 4.44vw 4.44vw;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.scr-inner {
  min-height: 100%;
  transition: transform .2s;
  will-change: transform;
}

.scr::-webkit-scrollbar {
  display: none;
}

.sec-lbl {
  font-size: 3.06vw;
  font-weight: 600;
  letter-spacing: 0.0005em;
  color: rgba(246, 217, 170, 0.5);
  text-transform: uppercase;
  padding: 3.33vw 0 2.22vw;
}

/* ── CARD ── */
.card {
  background: #1a1a1a;
  border-radius: 4.44vw;
  margin-bottom: 2.777vw;
  padding: 3.89vw 4.44vw;
  border: 0.3vw solid rgba(255, 255, 255, 0.06);
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.67vw;
}

.card-q {
  color: #fff;
  font-size: 4.166vw;
  font-weight: 600;
  line-height: 1.35;
  flex: 1;
  padding-right: 2.22vw;
}

.card-sub {
  color: rgba(255, 255, 255, 0.4);
  font-size: 3.61vw;
  font-weight: 400;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 1.67vw;
  margin-bottom: 2.777vw;
}

.card-date {
  color: rgba(255, 255, 255, 0.4);
  font-size: 3.333vw;
}

.card-src {
  color: rgba(255, 255, 255, 0.3);
  font-size: 3.06vw;
}

.dot {
  color: rgba(255, 255, 255, 0.2);
  font-size: 2.777vw;
}

.live-badge {
  display: flex;
  align-items: center;
  gap: 1.11vw;
  background: rgba(246, 217, 170, 0.1);
  border-radius: 5.555vw;
  padding: 0.83vw 2.22vw;
  flex-shrink: 0;
}

.live-dot {
  width: 1.67vw;
  height: 1.67vw;
  border-radius: 50%;
  background: var(--primary-color);
  animation: pulse 1.8s ease-in-out infinite;
}

.live-txt {
  color: var(--primary-color);
  font-size: 2.777vw;
  font-weight: 600;
  letter-spacing: 0.08vw;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(1.35);
  }
}

.opt-row {
  display: flex;
  gap: 2.22vw;
}

.opt-btn {
  flex: 1;
  padding: 2.777vw 2.22vw;
  border-radius: 2.777vw;
  border: 0.42vw solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6vw;
  cursor: pointer;
}

.opt-btn.yes-sel {
  border-color: #4caf82;
  background: rgba(76, 175, 130, 0.12);
}

.opt-btn.no-sel {
  border-color: #e05c5c;
  background: rgba(224, 92, 92, 0.1);
}

.opt-lbl {
  font-size: 3.888vw;
  font-weight: 700;
  color: #fff;
}

.opt-odds {
  font-size: 3.06vw;
  color: rgba(255, 255, 255, 0.45);
}

.opt-btn.yes-sel .opt-lbl {
  color: #4caf82;
}

.opt-btn.yes-sel .opt-odds {
  color: rgba(76, 175, 130, 0.7);
}

.opt-btn.no-sel .opt-lbl {
  color: #e05c5c;
}

.opt-btn.no-sel .opt-odds {
  color: rgba(224, 92, 92, 0.7);
}

.amt-row {
  display: flex;
  gap: 2.22vw;
  margin-top: 2.78vw;
  align-items: center;
}

.amt-input {
  flex: 1;
  background: rgba(255, 255, 255, 0.07);
  border: 0.28vw solid rgba(255, 255, 255, 0.1);
  border-radius: 2.22vw;
  padding: 2.50vw 3.33vw;
  color: #fff;
  font-size: 4.166vw;
  font-weight: 600;
  outline: none;
  text-align: center;
}

.amt-input.err {
  border-color: #e05c5c;
  background: rgba(224, 92, 92, 0.07);
}

.bet-btn {
  background: var(--primary-color);
  color: #090909;
  font-size: 3.888vw;
  font-weight: 700;
  border: none;
  border-radius: 2.22vw;
  padding: 2.50vw 5.00vw;
  flex-shrink: 0;
}

.bet-btn.dis {
  background: rgba(246, 217, 170, 0.25);
  color: rgba(9, 9, 9, 0.4);
}

.err-msg {
  color: #e05c5c;
  font-size: 3.333vw;
  margin-top: 1.67vw;
  display: flex;
  align-items: center;
  gap: 1.11vw;
}

.err-ic {
  width: 3.89vw;
  height: 3.89vw;
  border-radius: 50%;
  background: #e05c5c;
  color: #fff;
  font-size: 2.50vw;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.closed-badge {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.4);
  font-size: 2.777vw;
  font-weight: 600;
  letter-spacing: 0.0005em;
  text-transform: uppercase;
  border-radius: 5.555vw;
  padding: 0.83vw 2.22vw;
}

.opt-dis {
  flex: 1;
  padding: 2.777vw 2.22vw;
  border-radius: 2.777vw;
  border: 0.42vw solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.02);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6vw;
}

.opt-dis .opt-lbl {
  color: rgba(255, 255, 255, 0.2);
  font-size: 3.888vw;
  font-weight: 700;
}

.opt-dis .opt-odds {
  color: rgba(255, 255, 255, 0.15);
  font-size: 3.06vw;
}

.res-row {
  margin-top: 2.22vw;
  display: flex;
  align-items: center;
  gap: 1.67vw;
}

.res-lbl {
  font-size: 3.333vw;
  color: rgba(255, 255, 255, 0.4);
}

.res-pending {
  font-size: 3.333vw;
  color: rgba(246, 217, 170, 0.6);
  font-weight: 500;
}

.res-yes {
  font-size: 3.61vw;
  color: #4caf82;
  font-weight: 700;
}

.res-no {
  font-size: 3.61vw;
  color: #e05c5c;
  font-weight: 700;
}

.divider {
  height: 0.28vw;
  background: rgba(255, 255, 255, 0.05);
  margin: 1.11vw 0 0;
}

/* MY BETS */
.bet-card {
  background: #1a1a1a;
  border-radius: 3.89vw;
  margin-bottom: 2.22vw;
  padding: 3.61vw 3.89vw;
  border: 0.3vw solid rgba(255, 255, 255, 0.06);
}

.bet-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.11vw;
}

.bet-q {
  color: #fff;
  font-size: 3.888vw;
  font-weight: 600;
  line-height: 1.3;
  flex: 1;
  padding-right: 2.22vw;
}

.bet-date {
  color: rgba(255, 255, 255, 0.35);
  font-size: 3.333vw;
  line-height: 4.8vw;
  flex-shrink: 0;
}

.bet-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2.22vw;
  padding-top: 2.22vw;
  border-top: 0.28vw solid rgba(255, 255, 255, 0.06);
}

.bet-sa {
  display: flex;
  align-items: center;
  gap: 1.67vw;
}

.pill {
  font-size: 3.06vw;
  font-weight: 700;
  padding: 0.83vw 2.22vw;
  border-radius: 5.555vw;
  text-transform: uppercase;
  width: 10.5vw;
  text-align: center;
}

.yes-pill {
  background: rgba(76, 175, 130, 0.15);
  color: #4caf82;
}

.no-pill {
  background: rgba(224, 92, 92, 0.12);
  color: #e05c5c;
}

.b-amt {
  color: rgba(255, 255, 255, 0.5);
  font-size: 3.61vw;
}

.s-won {
  color: #4caf82;
  font-size: 3.61vw;
  font-weight: 700;
}

.s-lost {
  color: rgba(255, 255, 255, 0.3);
  font-size: 3.61vw;
}

.s-pend {
  color: rgba(246, 217, 170, 0.6);
  font-size: 3.61vw;
}

.hint {
  color: rgba(255, 255, 255, 0.2);
  font-size: 3.333vw;
  text-align: center;
  padding: 3.33vw 0;
}

/* SHEET */
.sheet-wrap {
  width: 100vw;
  height: 100dvh;
  background: #090909;
  overflow: hidden;
  border: 0.42vw solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}

.sheet-won {
  position: relative;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  z-index: 2;
}

.sheet-overlay {
  position: absolute;
  bottom: 0;
  border-radius: 6.67vw 6.67vw 0 0;
  z-index: 3;
}

.sheet {
  background: #141414;
  border-radius: 5.555vw 5.555vw 0 0;
  padding: 0 0 7.777vw;
  border-top: 0.3vw solid rgba(255, 255, 255, 0.08);
  animation: slideInFromBottom 0.15s ease-out forwards;
}

@keyframes slideInFromBottom {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.anno-wrap {
  display: flex;
  gap: 0;
  align-items: flex-start;
  position: relative;
}

.redline-panel {
  width: 55.555vw;
  flex-shrink: 0;
  position: relative;
}

.screen-label {
  font-size: 3.06vw;
  color: rgba(246, 217, 170, 0.4);
  font-weight: 600;
  letter-spacing: 0.0005em;
  text-transform: uppercase;
  margin-bottom: 2.777vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/PredictRecord/index.vue